import React from 'react';
import { Card, Flex, Tag, Typography } from 'antd';
import { DollarOutlined, LockOutlined } from '@ant-design/icons';
import { JourneyState } from 'interfaces/journey';
import { formatAmount, hasAmount, NO_AMOUNT } from 'util/amount';
import { useJourneyDashboardContext } from '../context';

const { Text } = Typography;

// Desde que la ruta arranca, ms-journey deja el estimativo fijo.
const FROZEN_STATES = [
  JourneyState.Started,
  JourneyState.Transfering,
  JourneyState.Finished,
];

// El estimativo de ms-journey, siempre visible en una ruta de colectas: sin
// monto lo dice, para que no parezca que falta algo.
const CollectionsAmountSummary: React.FC = () => {
  const { estimatedCollectionsAmount, state } = useJourneyDashboardContext();
  const withAmount = hasAmount(estimatedCollectionsAmount);
  const frozen = !!state && FROZEN_STATES.includes(state);

  return (
    <Card bodyStyle={{ padding: '10px 16px' }}>
      <Flex align="center" justify="space-between" gap={8}>
        <Flex align="center" gap={8}>
          <DollarOutlined style={{ color: '#595959', fontSize: 16 }} />
          <Text>Valor total de la ruta</Text>
        </Flex>
        <Flex align="center" gap={8}>
          {frozen && (
            <Tag icon={<LockOutlined />} style={{ margin: 0 }}>
              Fijo
            </Tag>
          )}
          {withAmount ? (
            <Text strong style={{ fontSize: 18 }}>
              {formatAmount(estimatedCollectionsAmount)}
            </Text>
          ) : (
            <Text type="secondary">{NO_AMOUNT}</Text>
          )}
        </Flex>
      </Flex>
    </Card>
  );
};

export default CollectionsAmountSummary;
